<p-toast></p-toast>
<p-panel header="{{windowsTitle}}" *ngIf="true">
  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">

    <!--<p-accordionTab [selected]="userInfoLoaded" [disabled]="(userAccessGroup < 1000000)" cache="false">
      <ng-template pTemplate="header">
        <h5>Helper Service Api Test</h5>
      </ng-template>
      <p-card header="Simple Card">
        <p class="m-0">
          {{demoServerApiText}}
        </p>
      </p-card>
    </p-accordionTab>-->

    <!-- *ngIf, not just [disabled] -- PrimeNG's [disabled] only blocks the
         click-driven toggle() and has no effect on [selected]; more
         fundamentally, the <app-edit-*> components below are plain projected
         content, not something PrimeNG's own cache/selected machinery gates
         at all -- Angular instantiates them, and their own ngOnInit() calls,
         unconditionally the moment this template renders, regardless of the
         parent p-accordionTab's disabled/selected state. *ngIf stops Angular
         from ever constructing them for a user who lacks canAccessAdminTabs. -->
    <p-accordionTab *ngIf="canAccessAdminTabs" [selected]="(userAccessGroup != 0)" cache="false">
      <ng-template pTemplate="header">
        <h5>Пользователи и доступ</h5>
      </ng-template>
      <app-edit-user-access-tab appStopAccordionHomeEnd></app-edit-user-access-tab>
    </p-accordionTab>

    <p-accordionTab *ngIf="canAccessAdminTabs" [selected]="false" cache="false">
      <ng-template pTemplate="header">
        <h5>Группы доступа</h5>
      </ng-template>
      <app-edit-access-groups-tab appStopAccordionHomeEnd></app-edit-access-groups-tab>
    </p-accordionTab>

  </p-accordion>
</p-panel>
